import api from '@/sui/api/api'
import delay from '@/sui/api/delay'

let module = null

const remote = true
if (remote) {
  module = {
    all (request) {
      return api.post('/sheet/all', request)
    },

    full (request) {
      return api.post('/sheet/full', request)
    },

    fromPeriod (request) {
      return api.post('/sheet/period', request)
    },

    add (request) {
      return api.post('/sheet/add', request)
    },

    update (request) {
      return api.post('/sheet/update', request)
    },

    get (request) {
      return api.post('/sheet/get', request)
    },

    remove (request) {
      return api.post('/sheet/remove', request)
    },

    statuses (request) {
      return api.post('/sheet/statuses', request)
    },

    filterByDisc (request) {
      return api.post('/sheet/filterbydisc', request)
    },

    fromVersion (request) {
      return api.post('/sheet/fromversion', request)
    }
  }
} else {
  module = {
    _bactADI: [],
    _reaBactADI: [],
    _reaInfADI: [],
    _neoInfADI: [],
    _diaInfADI: [],

    all (request) {
      return delay(150)({
        data: {
          v: this[`_${request.t}`].slice()
        }
      })
    },

    add (request) {
      const list = this[`_${request.t}`]
      const id = list.length
      request.id = String(id)
      list.push(request)
      return delay(150)({
        data: {
          id: id
        }
      })
    },

    update (request) {
      const id = request.id
      this[`_${request.t}`][id] = request
      return delay(1450)({
        data: {
          id: id
        }
      })
    },

    get (request) {
      const result = this[`_${request.t}`].find(e => e.id === request.id)
      const data = {}

      if (result != null) {
        data.v = result
      } else {
        data.err = `Invalid fake id ${request.id}.`
      }

      return delay(400)({ data: data })
    }
  }
}
export default module
